import React from "react";
import { useOutletContext } from "react-router-dom";
import MainDashboard from "../components/Dashboard/MainDashboard";
import Sidebar from "../components/common/Sidebar";
import { InspectionRefreshContext } from "../components/common/Layout";

export default function Dashboard(): React.ReactElement {
    const { onInspectionCreated } = useOutletContext<InspectionRefreshContext>();

    return (
        <>
            <div className="flex overflow-hidden h-full">
                <Sidebar onInspectionCreated={onInspectionCreated} />
                <div className={`flex-1 h-full overflow-hidden bg-gray-4`}>
                    <MainDashboard />
                </div>
            </div>
        </>
    );
};